import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { JobAttachmentsService } from 'src/app/core/services/http/attachments/job-attachments.service';
import { TosterService } from 'src/app/core/services/toster/toster.service';
import { EMPTY_GUID } from '../../constants/empty-guid-.constant';
import { EditImage } from '../../models/edit-image.model';
import { Attachment } from '../../models/uploaded-file-list.model';
import { FileService } from '../../services/file.service';
import { Job } from 'src/app/job/models/job-post/job.model';
import { JobDetailsMode } from 'src/app/job/constants/assign-trade.constant';

declare var Pixie: any;
declare var $: any;

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss'],
})
export class ImageEditorComponent implements OnInit {
  ImageDetails: Attachment;
  pixie: any;
  newAttachments: any;
  jobId: string;
  comment: string = '';
  imageDetails: EditImage = new EditImage();

  @Input() set imgJobId(value: string) {
    if (value == undefined) {
      value = EMPTY_GUID;
    }
    this.jobId = value;
  }
  @Input() set selectedImage(value: any) {
    let att = new Attachment();
    att.name = value.fileName;
    att.blobUrl = value.fileUrl;
    att.blobName = value.fileName;
    this.imageDetails.isAfter = value.isAfter;
    this.comment = value.comment;
    if (value && value.blobUrl && value.blobUrl != null) {
      this.ImageDetails = value;
      this.imageDetails.comment = this.comment;
      this.imageEditor(value.blobUrl);
    }
  }
  @Output() closeEvent = new EventEmitter();
  constructor(
    private jobAttachmentService: JobAttachmentsService,
    private ngZone: NgZone,
    private toaster: TosterService,
    private fileService: FileService
  ) {
    window['ImageEditorComponent'] = { component: this, zone: ngZone };
  }

  ngOnInit(): void {
    this.pixie = new Pixie({
      image: '../../../../../assets/images/default-image.svg',
      compact: true,
      crossOrigin: true,
      openImageDialog: {
        show: false,
      },
      ui: {
        mode: 'inline',
        theme: 'light',
        allowEditorClose: true,
        allowZoom: true,
        toolbar: {
          hideOpenButton: false,
          hideCloseButton: true,
        },
      },
      urls: {
        assets: '../../../../../assets/images/pixie/',
      },
      onSave: function (data, name) {
        var imageData = appendFileAndSubmit(data);
        window['ImageEditorComponent'].zone.run(() => {
          window['ImageEditorComponent'].component.saveImage(imageData, name);
        });
      },
    });
    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || 'image/png';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });

      return blob;
    }
    function appendFileAndSubmit(ImageURL) {
      var block = ImageURL.split(',');
      var realData = block[1];
      var content = block[0].split(';')[0];
      var extension = content.split(':')[1];
      var blob = b64toBlob(realData, extension, 512);

      return blob;
    }
  }

  imageEditor(clickedImage) {
    (async () => {
      await delay(500);
      this.pixie.resetEditor('image', clickedImage);
    })();
    function delay(ms: number) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
  }

  saveImage(imageData: any, name: any) {
    const formData = this.appendFile(imageData, name);
    //let imageDetails = new EditImage();
    //this.imageDetails.jobId = this.jobId;
    this.imageDetails.file = formData;
    let job = Job.getInstance();
    let isFromJobEdit = job.mode == JobDetailsMode.EDIT ? true : false;
    if (this.jobId && formData) {
      this.jobAttachmentService.editImage(this.imageDetails,isFromJobEdit).subscribe({
        next: (res) => {
          this.toaster.success('File saved successfully');
          //Image edited in job post (Job Id is empty)
          if (this.jobId == EMPTY_GUID || isFromJobEdit) {
            let attachment = new Attachment();
            attachment.name = res.name;
            attachment.blobName = res.name;
            attachment.blobUrl = res.url;
            attachment.comment = this.comment;
            attachment.isAfter = this.imageDetails.isAfter;
            this.fileService.fileAddEvent.next(attachment);
          }
          this.dismiss();
        },
        error: (err) => {
          this.toaster.error(err.message);
        },
      });
    } else {
      this.toaster.error('You can not edit this image');
    }
  }

  private appendFile(file: any, name: any): FormData {
    const formData = new FormData();
    formData.append('jobId', this.jobId);
    formData.append('file', file, name);
    formData.append('isAfter', JSON.stringify(this.imageDetails.isAfter));
    if (this.comment != undefined)
      formData.append('comment', this.comment);

    return formData;
  }

  updateComment(text) {
    this.comment = text;
  }

  dismiss() {
    this.closeEvent.emit();
  }
}
